<div class="PGRealmInvite text-center">
    @if (isLoggedIn() && realmData != null) {
        <div>
            @if (isRequestingAddRealm) {
                <app-pg-loading [isOverlay]="true"></app-pg-loading>
            }
            <div class="PGRealmInvite-Card pt-3">
                <div class="card">
                    <div class="card-body">
                        <app-pg-realm-card [realmData]="realmData"></app-pg-realm-card>
                    </div>
                </div>
            </div>
            <div class="mt-3">
                @if (!getRealmStatus()) {
                    <button class="btn btn-primary" [disabled]="isRequestingAddRealm" (click)="requestAddRealm()">
                        <i class="fa-regular fa-user-plus"></i>
                        <span>{{ 'pg-realm-invite.request-access' | locTranslate }}</span>
                    </button>
                }
                @if (getRealmStatus(); as status) {
                    <div>
                        @if (status == 'unavailable') {
                            <div class="text-danger">{{ 'pg-realm-invite.status-unavailable' | locTranslate }}</div>
                        }
                        @if (status == 'available') {
                            <div>{{ 'pg-realm-invite.status-available' | locTranslate }}</div>
                        }
                        @if (status == 'pending') {
                            <div>{{ 'pg-realm-invite.status-pending' | locTranslate }}</div>
                        }
                    </div>
                }
            </div>
        </div>
    }
</div>
